module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-menu"
  }, _vm._l((_vm.data), function(node) {
    return _c('i-menu-node', {
      attrs: {
        "node": node
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9db0c99a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/src/menu.vue
// module id = 670
// module chunks = 0